module.exports = __webpack_public_path__ + "media/restaurant-bell.b450e746.mp3";